module.exports = __webpack_public_path__ + "static/media/error.5be1b293.png";